import { z } from 'zod';

export const dealerDirectoryQuickLinksSchema = z.object({
  internalLinks: z.array(
    z.object({
      text: z.string(),
      url: z.string(),
    }),
  ),
  type: z.literal('popular'),
});

export type DealerDirectoryQuickLinksResponse = z.infer<
  typeof dealerDirectoryQuickLinksSchema
>;
